webpackJsonp([23],{

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

var mc = __webpack_require__(0);
mc.runVue(['Slider', 'Navigation', 'selectList']);
mc.runComponents(['rating']);
mc.runFooter();

$('body').on('ajaxResponse', function () {
	mc.runVue(['selectList']);
});

/***/ })

},[91]);


// WEBPACK FOOTER //
// bundles/contact.bundle.js